// src/api/userApi.ts
import axiosInstance from './Instance/axiosInstance';
import { User } from '../types/user';

// ✅ Create a new user
export const createUser = async (user: Omit<User, 'id'>): Promise<User> => {
    const response = await axiosInstance.post('/users', user);
    return response.data;
};

// ✅ Get all users
export const getUsers = async (): Promise<User[]> => {
    const response = await axiosInstance.get('/users');
    return response.data;
};

// ✅ Update user by ID
export const updateUser = async (id: string, user: Partial<User>): Promise<User> => {
    const response = await axiosInstance.put(`/users/${id}`, user);
    return response.data;
};

// ✅ Delete user by ID
export const deleteUser = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/users/${id}`);
};
